import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PermissionsCampus, UserState } from "../../types/types.user";

// Define the initial state using that type
const initialState: UserState = {
  Loading: false,
  Error: null
}

export const authSlice = createSlice({
  name: 'configuration',
  initialState,  
  reducers: {
    login: (state, action:PayloadAction<UserState>) => {
      return action.payload
    },
    logOut: (state) => {
      const userState :UserState ={

      }
      return userState
    },
    putPermissionsCampus: (state, action: PayloadAction<PermissionsCampus[]>) => {
      state.PermissionsCampus = action.payload
      state.Loading = false
      state.Error = null
      state.Profile = null
      state.Permissions = null
      state.Token = null
      state.User = null
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.Loading = action.payload
      if (action.payload) {
        state.Error = null
        state.Profile = null
        state.Permissions = null
        state.Token = null
        state.User = null
      }
    },
    setError: (state, action: PayloadAction<string>) => {
      state.Error = action.payload
      state.Profile = null
      state.Permissions = null
      state.Token = null
      state.User = null
      state.Loading=false
    }
  }
})

export const { login, logOut, setError, setLoading, putPermissionsCampus } = authSlice.actions;



